<div class="wifi-calling-page">
    <section class="video-section">
        <video class="video" id="wifi-calling-video" poster="assets/img/wifi-calling-poster.png" [muted]="true" preload="auto"
            autoplay playsinline loop>
            <source src="assets/videos/wifi-calling-video.mp4" type="video/mp4">
            Video tag is not supported in this browser.
        </video>
        <div class="banner-text">
            <h1 class="header">Wi-Fi Calling</h1>
            <p class="sub-header">Talk, text and surf the web in more places</p>
        </div>
    </section>
    <section class="extend-calling-section wifi-section">
        <div class="text-part">
            <div class="content margin-bottom">
                <h2 class="title">Extend your calling to more places</h2>
                <p>Live in a more rural area where cellular networks aren’t robust? Work in an
                    ultra-tall building or a basement where cell coverage isn’t reliable? Or maybe your new apartment
                    has argon glass windows which can make it difficult to get a strong cellular network signal. Use
                    Wi-Fi calling to stay connected. </p>
            </div>
            <div class="content">
                <h2 class="title">Stay connected outside the US</h2>
                <p>Wi-Fi Calling can be used in the domestic coverage areas of the US and for most
                    international countries. <a
                        [routerLink]="[SUPPORT_ROUTE_URLS.BASE+'/'+SUPPORT_ROUTE_URLS.INTERNATIONAL_CALLING]">See
                        international countries included</a>.</p>
            </div>
        </div>
        <div class="image-part">
            <picture>
                <source srcset='assets/img/globe-mobile.svg' media="(max-width: 639.9px)">
                <source srcset='assets/img/globe-tablet.svg' media="(max-width: 1024.9px)">
                <source srcset='assets/img/globe-desktop.svg' media="(min-width: 1025px)">
                <img src="assets/img/globe-desktop.svg" alt="globe-image">
            </picture>
        </div>
    </section>
    <section class="calling-on-the-fly-section wifi-section">
        <h2 class="title">Wi-Fi calling on the fly!</h2>
        <div class="flex-phones">
            <div class="phone-part">
                <picture>
                    <source srcset='assets/img/man-phone.webp' type="image/webp">
                    <source srcset='assets/img/man-phone.png' type="image/png">
                    <img src="assets/img/man-phone.png" alt="man-phone-image">
                </picture>
            </div>
            <div class="arrow-part">
                <picture>
                    <source srcset='assets/icon/fly-down-arrow.svg' media="(max-width: 639.9px)">
                    <source srcset='assets/icon/fly-right-arrow.svg' media="(min-width: 640px)">
                    <img src="assets/icon/fly-right-arrow.svg" alt="arrow-icon">
                </picture>
            </div>
            <div class="phone-part">
                <picture>
                    <source srcset='assets/img/girl-phone.webp' type="image/webp">
                    <source srcset='assets/img/girl-phone.png' type="image/png">
                    <img src="assets/img/girl-phone.png" alt="girl-phone-image">
                </picture>
            </div>
        </div>
        <div class="description-part">
            <p class="desc desc-margin">WiFi Calling is easy to setup and use. WiFi Calling works with your FreeUP
                mobile number and compatible
                device—no new number or special app required.</p>
            <p class="desc">Once enabled, Wi-Fi Calling works automatically. Just connect your phone to a Wi-Fi network
                and you are
                set. No additional numbers, logins required or additional costs.</p>
        </div>
    </section>
    <section class="calling-with-wifi-section wifi-section">
        <h2 class="title">Calling and texting with Wi-Fi Calling</h2>
        <div class="description">
            <p class="desc desc-margin">Calls are billed based on the number you call, no matter whether you are using
                Wi-Fi at home or while
                traveling abroad.</p>
            <p class="desc desc-margin">When using Wi-Fi calling, calls to U.S. numbers can be made at no additional
                charge even when you’re
                traveling internationally. Unlike “Wi-Fi first” carriers, you can make international calls on FreeUP
                Mobile with Wi-Fi calling. Calls to international numbers are billed at your <a
                    [routerLink]="[SUPPORT_ROUTE_URLS.BASE+'/'+SUPPORT_ROUTE_URLS.INTERNATIONAL_CALLING]">international
                    long-distance
                    rates</a>. If you are traveling abroad, this includes calls to the country you are in.</p>
            <p class="desc">Calls to premium numbers such as 411 are billed at standard premium rates.
                Text messages you send or receive count the same as regular text messages. You will be charged according
                to your current rate plan.</p>
        </div>
    </section>
</div>